/* istanbul ignore file */
import { StaticFilters as Filters, ListFiltersLayout as FiltersLayout, DateTimeRangeFilter } from 'framework/list';
import useCrmActivityItem from 'domain/sales/shared/timeline/activity/crmActivityRegistry';
import useCrmNoteItem from 'domain/sales/shared/timeline/note/crmNoteRegistry';
import CrmTimelineEntryTypeFilter from 'domain/sales/shared/timeline/filter/CrmTimelineEntryTypeFilter';
import { Show } from 'framework/show';
import { Timeline, TimelinePageLayout, TimelineLayout } from 'framework/ui/timeline';
import { useAccountId } from 'domain/sales/account/accountRouting';
import ShowAccountPageMenu from 'domain/sales/account/Show/ShowAccountPageMenu';
import AccountEntityHeader from 'domain/sales/account/shared/AccountEntityHeader';
import AccountTimelineBreadcrumbs from 'domain/sales/account/Timeline/Breadcrumbs';
import useCrmStrategyNoteItem from '../../shared/timeline/strategyNote/useStrategyNoteItem';
import { TimelineItem, TimelineRegistry } from 'framework/ui/timeline';
import useAccountManagementService from '../useAccountManagementService';

const AccountTimelinePage = () => {
  const accountId = useAccountId();
  const {
    getById,
    searchTimelineItems,
    createTimelineItem,
    getTimelinePageById,
    getFilterValidationSchema,
    pinAccountTimeline,
  } = useAccountManagementService();

  const activityRegistry = useCrmActivityItem();
  const noteRegistry = useCrmNoteItem();
  const strategyNoteRegistry = useCrmStrategyNoteItem();
  const registries = [noteRegistry, strategyNoteRegistry, activityRegistry] as unknown as TimelineRegistry[];

  const filters = (
    <Filters getValidationSchema={getFilterValidationSchema}>
      <FiltersLayout>
        <CrmTimelineEntryTypeFilter label="Entry type" source="type" />
        <DateTimeRangeFilter label="Created date" source="createdAt" />
      </FiltersLayout>
    </Filters>
  );
  return (
    <Show getDataMethod={() => getById(accountId)}>
      <Timeline
        registries={registries}
        getDataMethod={request => searchTimelineItems(accountId, request)}
        pinTimelineAction={pinAccountTimeline}
        createTimelineItemMethod={(itemType, request) =>
          createTimelineItem(accountId, itemType, request) as Promise<TimelineItem>
        }
        getPageByEntryIdMethod={id => getTimelinePageById(accountId, id)}
      >
        <TimelinePageLayout
          menu={<ShowAccountPageMenu />}
          breadcrumbs={<AccountTimelineBreadcrumbs />}
          entityHeader={<AccountEntityHeader />}
          filter={filters}
          titleVariant="h4"
        >
          <TimelineLayout noEntriesMessage="No entries in this account timeline yet." />
        </TimelinePageLayout>
      </Timeline>
    </Show>
  );
};

export default AccountTimelinePage;
